var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUsIco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3833 0.500732H4.6167C2.07105 0.500732 0 2.57178 0 5.11743V26.7846C0 29.3304 2.07115 31.4013 4.6167 31.4013H18.4452V33.6551H14.9824C14.0408 33.6551 13.2776 34.4182 13.2776 35.3598V39.1788C13.2776 40.1204 14.0408 40.8836 14.9824 40.8836H30.0178C30.9592 40.8836 31.7226 40.1204 31.7226 39.1788V35.36C31.7226 34.4184 30.9592 33.6552 30.0178 33.6552H26.5551V31.4015H40.3833C42.9288 31.4015 45 29.3304 45 26.7848V5.11743C45 2.57178 42.9289 0.500732 40.3833 0.500732ZM40.8963 26.7848C40.8963 27.0677 40.666 27.2978 40.3833 27.2978H31.8079C31.3629 26.0705 30.9758 25.1481 30.9758 25.1481C30.7708 24.6581 30.2781 24.3442 29.8074 24.1513L26.6264 22.6868L25.0981 21.398L22.6425 23.8405L23.1598 27.2977H21.8402L22.3573 23.8404L19.9019 21.398L18.3736 22.6867L15.1926 24.1511C14.7219 24.344 14.2208 24.674 14.0242 25.148C14.0242 25.148 13.6369 26.0705 13.1921 27.2976H4.6167C4.33395 27.2976 4.10373 27.0676 4.10373 26.7846V5.11743C4.10373 4.83458 4.33395 4.60447 4.6167 4.60447H40.3833C40.666 4.60447 40.8963 4.83458 40.8963 5.11743V26.7848Z",
    fill: "url(#paint0_linear_2332_171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4117 12.381C30.2267 10.513 29.5214 8.94499 28.3414 7.80159C27.0885 6.5876 25.3141 5.86678 23.1824 5.69904C23.1824 5.69904 22.9533 5.67944 22.4999 5.67944C22.0467 5.67944 21.8177 5.69904 21.8177 5.69904C19.6859 5.86678 17.9117 6.5876 16.6588 7.80159C15.4785 8.94499 14.773 10.513 14.588 12.381C14.2241 12.4501 13.9482 12.7701 13.9482 13.1533V16.1814C13.9482 16.6153 14.3011 16.968 14.7345 16.968H15.6499C16.0837 16.968 16.4363 16.6153 16.4363 16.1814V13.1533C16.4363 12.8068 16.2109 12.5128 15.8992 12.408C16.2734 9.05199 18.6076 7.09113 22.4445 6.97448H22.5607C26.3948 7.09267 28.7269 9.05343 29.1007 12.408C28.7889 12.5128 28.5639 12.8068 28.5639 13.1533V16.1814C28.5639 16.6153 28.9164 16.968 29.3502 16.968H30.2655C30.699 16.968 31.052 16.6153 31.052 16.1814V13.1533C31.0517 12.77 30.7758 12.4501 30.4117 12.381Z",
    fill: "url(#paint1_linear_2332_171)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 7.83228C18.4081 7.83228 16.7279 9.94324 16.764 13.4706C16.8189 18.5536 19.2467 21.5846 22.4998 21.5846C25.7531 21.5846 28.1808 18.5536 28.2361 13.4706C28.2715 9.94334 26.5915 7.83228 22.4998 7.83228Z",
    fill: "url(#paint2_linear_2332_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2332_171",
    x1: 22.4983,
    y1: 0.500732,
    x2: 22.4983,
    y2: 40.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2332_171",
    x1: 22.4995,
    y1: 5.67944,
    x2: 22.4995,
    y2: 16.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2332_171",
    x1: 22.4996,
    y1: 7.83228,
    x2: 22.4996,
    y2: 21.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIco4);
export default __webpack_public_path__ + "static/media/why-us-ico-4.7dd7bb0418759226f8844da326b20ada.svg";
export { ForwardRef as ReactComponent };